// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__jrSZe","box":"WorkspacesBox_box__2v3gm","node":"WorkspacesBox_node__11YER"};